export const ADVISER_IDENTIFIER: string = "303b5969-b206-4111-a1b9-0c5a7853e477"
export const QUESTIONS_API_URL: string = "https://d3nccqlgxy2d29.cloudfront.net"
// export const QUESTIONS_API_URL: string = "http://54.162.148.68"
export const SERVICES_API_URL: string = "https://o6wb596uc7.execute-api.us-east-1.amazonaws.com/dev"
// export const SERVICES_API_URL: string = "http://localhost:8081"
export const PREDICT_API_URL: string = "https://byj6s1gin0.execute-api.us-east-1.amazonaws.com/dev"
// export const PREDICT_API_URL: string = "http://localhost:8082"
// export const ANSWERS_API_URL: string = "https://d3hxytqo2w5jux.cloudfront.net" // JUST ENTEL
export const ANSWERS_API_URL: string = "https://d1vmmc9g154f9b.cloudfront.net"
// export const ANSWERS_API_URL: string = "http://127.0.1:8000"
export const CONTACT_API_URL: string = "https://dia29x7l1g5qs.cloudfront.net"
export const ANALYTICS_API_URL: string = "https://b5kjzvxwik.execute-api.us-east-1.amazonaws.com/dev"
// HUBSPOT INTEGRATION
export const HUBSPOT_API_URL: string = "https://api.hsforms.com/submissions/v3/integration/submit/"
export const HUBSPOT_KEYS: { [key: string]: string } = {
  portalId: "6758175",
  formId: "0a96b5ca-07fa-40d6-b1be-0f5795d73188"
}
export const SENDGRID_SERVICE_URL: string = "https://u16g93pgve.execute-api.us-east-1.amazonaws.com/prod/send-recommended-notification---XXX"
export const EMAIL_TO: string = "csguzman@entel.cl,pcvargas@entel.cl,petorres@entel.cl,i2b_rgonzaleze@externos.entel.cl,ncartes@entel.cl"
export const ANALYTICS_KEY: string = 'G-6Q1RPEL7E7'
export const TAG_MANAGER_KEY: string = 'GTM-W9D6BMQ'
export const DEV_MODE: boolean = true;
export const CHAT_BETA_URL: string = "https://iknmh7qqhj.execute-api.us-east-1.amazonaws.com/dev"